import React, {FC} from 'react';
import {LocationFavoriteSearchViewVO} from "../../../types/model/valueObject/location/LocationFavoriteSearchViewVO";
import LocationFavoriteIcon from "../../location/LocationFavoriteIcon";
import NotLiveLocationChip from "../../NotLiveLocationChip";
import {generateLocationProfileLink} from "../../../util/LinkUtils";
import {formatCurrencyValue} from "../../../util/PaymentUtils";
import LocationCard from "../../deprecatedUikit/LocationCard/LocationCard";
import {LocationItemLinkRoot, LocationItemNonLinkRoot} from "../../location/styles";

/*
* Notes (cmm): this file is basically a shim to be able to use LocationCard with the
* LocationFavoriteSearchViewVO type. Once LocationCard is retired, this component
* should be refactored to use the newer components. That should include deleting:
* - locationItemLinkStyles
* - LocationCard
* - buyerLocationFavoriteCardHeadCells
*/

const buyerLocationFavoriteCardHeadCells = [
  {id: 'locationFeatures', label: 'LOCATION FEATURES'},
  {id: 'locationEquipmentTypes', label: 'EQUIPMENT TYPES'},
  {id: 'monthlyRate', label: 'MONTHLY RATE'},
  {id: 'dailyRate', label: 'DAILY RATE'},
  {id: 'city', label: 'CITY'},
  {id: 'state', label: 'STATE'},
];

type BuyerLocationFavoriteCardListItemProps = {
  item: LocationFavoriteSearchViewVO;
}

/**
 * Component that displays all information for a single LocationFavoriteSearchViewVO (buyer favorite location card item)
 * @param item the LocationFavoriteSearchViewVO to display
 * @constructor
*/

const BuyerLocationFavoriteCardListItem: FC<BuyerLocationFavoriteCardListItemProps> = ({ item }) => {
  // Only treat as offline when we explicitly know live is false; missing/undefined
  // keeps the link intact (safe default if the backend hasn't sent the flag yet).
  const isOffline = item.live === false;

  const card = (
    <LocationCard
      data={{
        ...item,
        dailyRate: formatCurrencyValue(item.pricePerDay) as string,
        monthlyRate: formatCurrencyValue(item.pricePerMonth) as string,
      }}
      headCells={buyerLocationFavoriteCardHeadCells}
      isBuyer
      statusChip={isOffline ? <NotLiveLocationChip /> : undefined}
      IconButton={() => <LocationFavoriteIcon locationId={item.locationId} isFavorite={true}/>}
      showAddress={false}
    />
  );

  // Offline (deactivated) locations render without an href so buyers can't
  // navigate to an unavailable profile; the "Not Live" pill signals the state.
  return isOffline
    ? <LocationItemNonLinkRoot>{card}</LocationItemNonLinkRoot>
    : (
      <LocationItemLinkRoot to={generateLocationProfileLink(item.locationId)} target={'_blank'} rel={'noopener noreferrer'}>
        {card}
      </LocationItemLinkRoot>
    );
};

export { BuyerLocationFavoriteCardListItem };
